import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-items-start flex-xl-row flex-column-fluid" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-column flex-lg-row-auto w-xl-600px flex-row-fluid d-flex flex-center justfiy-content-xl-first\"><div class=\"d-flex align-items-start flex-column p-5 p-lg-15\"><a href=\"#\" class=\"mb-12\"><img alt=\"Logo\" src=\"media/logos/logo-melon.png\" class=\"h-65px\"></a><h1 class=\"text-dark fs-2x mb-3\">Bienvenido!</h1><div class=\"fw-bold fs-4 text-gray-400 mb-10\"> Tu solicitud está en proceso. </div></div></div>", 1)
const _hoisted_3 = { class: "flex-row-fluid d-flex flex-center justfiy-content-xl-first" }
const _hoisted_4 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body p-0" }
const _hoisted_7 = { class: "card-px text-center py-20 my-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "fs-2x fw-bolder mb-10" }, "Gracias", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 fs-5 fw-bold mb-13" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Hemos recibido correctamente su solicitud. Una vez confirmado recibirá un correo electrónico con las indicaciones para activar su cuenta.")
], -1)
const _hoisted_10 = { class: "text-center px-5" }
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary er fs-6 px-8 py-4",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args)))
              }, " Aceptar ")
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                src: _ctx.getIllustrationsPath('16.png'),
                alt: "",
                class: "mw-100 mh-300px"
              }, null, 8, _hoisted_11)
            ])
          ])
        ])
      ])
    ])
  ]))
}